/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.9",
    versionName: "0.2.0-nightly.2025.8.9",
    versionChannel: "nightly",
    buildDate: "2025-08-09T00:09:23.156Z",
    commitHash: "040f74062d3433d43a8830858e77affc184b9a3b",
};
